import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "@/hooks/stores/useAuth";
import { hasRoleAccess } from "@/lib/accessControl";

export const RoleProtectedRoute = ({ allowedRoles }) => {
  const { isAuthenticated, userRole } = useAuth();
  const location = useLocation();

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If user's role is not in the allowed roles list, redirect to unauthorized page
  if (!hasRoleAccess(userRole, allowedRoles)) {
    return <Navigate to="/unauthorized" replace state={{ from: location }} />;
  }

  // User is authenticated and has an allowed role
  return <Outlet />;
}; 